import type React from "react";
import "./SectionHeading.css";

export const SectionHeading = ({ children }: { children: React.ReactNode }) => (
	<h2 className="section-title">
		<span className="square-accent" />
		{children}
	</h2>
);
